import { CaseState, ComplaintFilters, ComplaintState, DecisionState, StatementState, UserStatus } from '../types/types';
import { texts } from './texts';
import moment from 'moment';

export const getStateBeschwerdeLabel = (stateKey: ComplaintState, short: boolean): string => {
	switch (stateKey) {
		case ComplaintState.NotAssigned:
			return short ? 'Nicht zugew.' : 'Nicht zugewiesen';
		case ComplaintState.Assigned:
			return short ? 'Zugew.' : 'Zugewiesen';
		case ComplaintState.NotResponsible:
			return short ? 'Nicht zust.' : 'Nicht zuständig';
		case ComplaintState.UnansweredCallbacks:
			return short ? 'off Rfr.' : 'mit offener Rückfrage';
		default:
			return '';
	}
};

export const getStateBeschwerdeColor = (stateKey: ComplaintState): string => {
	switch (stateKey) {
		case ComplaintState.NotAssigned:
			return 'red';
		case ComplaintState.NotResponsible:
			return 'black';
		case ComplaintState.Assigned:
		default:
			return 'green';
	}
};

export const getStateFallLabel = (stateKey: CaseState, short: boolean): string => {
	switch (stateKey) {
		case CaseState.NoStatus:
			return 'Kein Status';
		case CaseState.ExaminationSmallSenate:
			return short ? 'Im kl. Senat' : 'Prüfung im kleinen Senat';
		case CaseState.ExaminationWerberat:
			return short ? 'Im Werberat' : 'Prüfung im Werberat';
		case CaseState.ExaminationSmallSenateRunning:
			return short ? 'Im kl. Senat' : 'Prüfung im kleinen Senat laufend';
		case CaseState.ExaminationWerberatRunning:
			return short ? 'Im Werberat' : 'Prüfung im Werberat laufend';
		case CaseState.Statements:
			return short ? 'STN' : 'Stellungnahmen';
		case CaseState.DecisionSensitization:
			return short ? 'Sensi' : 'Entscheidung: Sensibilisierung';
		case CaseState.DecisionNoReason:
			return short ? 'Kein Grund' : 'Entscheidung: Kein Grund';
		case CaseState.DecisionStop:
			return short ? 'STOP' : 'Entscheidung: STOP';
		case CaseState.ImmediateSubjectWithdrawal:
			return short ? 'Rücknahme' : 'Sofortige Sujetrücknahme';
		case CaseState.NotResponsible:
			return short ? 'Nicht zust.' : 'Nicht zuständig';
		case CaseState.ProcedureNotPossible:
			return short ? 'Nicht mögl.' : 'Verfahren nicht möglich';
		case CaseState.Unfounded:
			return short ? 'Unbegründet' : 'Als unbegründet abgewiesen';
		default:
			return '';
	}
};

export const getStateFallColor = (stateKey: CaseState): string => {
	switch (stateKey) {
		case CaseState.ExaminationSmallSenateRunning:
		case CaseState.ExaminationSmallSenate:
		case CaseState.ExaminationWerberat:
		case CaseState.ExaminationWerberatRunning:
			return 'yellow';
		case CaseState.DecisionStop:
			return 'red';
		case CaseState.DecisionSensitization:
		case CaseState.ImmediateSubjectWithdrawal:
			return 'orange';
		case CaseState.NoStatus:
		case CaseState.Statements:
			return 'grey';
		case CaseState.ProcedureNotPossible:
		case CaseState.Unfounded:
		case CaseState.NotResponsible:
			return 'black';
		case CaseState.DecisionNoReason:
		default:
			return 'green';
	}
};

export const getStateEntscheidungColor = (stateKey: DecisionState): string => {
	switch (stateKey) {
		case DecisionState.Stop:
		case DecisionState.StopSmallSenate:
			return 'red';
		case DecisionState.GoSmallSenate:
		case DecisionState.NoReason:
			return 'green';
		case DecisionState.Awareness:
			return 'orange';
		case DecisionState.UserAbsent:
		case DecisionState.Null:
			return 'grey';
		case DecisionState.Biased:
		default:
			return 'black';
	}
};

export const getStateUserColor = (stateKey: UserStatus): string => {
	switch (stateKey) {
		case UserStatus.Pending:
			return 'yellow';
		case UserStatus.Active:
			return 'green';
		case UserStatus.Deactivated:
			return 'red';
		case UserStatus.Absent:
			return 'grey';
		default:
			return 'black';
	}
};

export const getStateStellungnahmeColor = (stateKey: StatementState): string => {
	switch (stateKey) {
		case StatementState.NotReceived:
			return 'grey';
		case StatementState.Received:
			return 'green';
		case StatementState.DeadlineExtended:
			return 'yellow';
		case StatementState.DeadlineExpired:
			return 'red';
		default:
			return 'black';
	}
};

export const getStateEntscheidungLabel = (stateKey: DecisionState, short: boolean): string => {
	switch (stateKey) {
		case DecisionState.Null:
			return 'Nicht entsch.';
		case DecisionState.NoReason:
			return short ? 'Kein Grund' : 'Entscheidung: Kein Grund';
		case DecisionState.Biased:
			return 'Befangen';
		case DecisionState.Stop:
			return short ? 'STOP' : 'Entscheidung: STOP';
		case DecisionState.Awareness:
			return short ? 'Sensi' : 'Entscheidung: Sensibilisierung';
		case DecisionState.UserAbsent:
			return short ? 'Abwesend' : 'Nicht anwesend';
		case DecisionState.GoSmallSenate:
			return short ? 'In den Rat' : 'In den Werberat';
		case DecisionState.StopSmallSenate:
			return short ? 'Unbegründet' : 'Als unbegründet abgewiesen';
		default:
			return '';
	}
};

export const getStateStellungnahmeLabel = (stateKey: StatementState, short: boolean): string => {
	switch (stateKey) {
		case StatementState.NotReceived:
			return short ? 'Nicht erh.' : 'Nicht erhalten';
		case StatementState.Received:
			return 'Erhalten';
		case StatementState.DeadlineExtended:
			return short ? 'Frist verl.' : 'Frist verlängert';
		case StatementState.DeadlineExpired:
			return short ? 'Frist abgel.' : 'Frist abgelaufen';
		case StatementState.StatementRejected:
			return short ? 'Abgelehnt' : 'Stellungnahme abgelehnt';
		default:
			return '';
	}
};

export const getStateUserLabel = (stateKey: UserStatus, short: boolean): string => {
	switch (stateKey) {
		case UserStatus.Pending:
			return 'Ausstehend';
		case UserStatus.Active:
			return 'Aktiv';
		case UserStatus.Deactivated:
			return 'Deaktiviert';
		case UserStatus.Absent:
			return 'Abwesend';
		default:
			return '';
	}
};

export const validateForm = async (formRef, id) => {
	if (!formRef || !id) {
		console.log('validateForm: formRef or id missing');
		return false;
	}

	const formEl = formRef.$refs[id + 'Ref'];
	if (!formEl) {
		console.log('validateForm: formEl not found');
		return false;
	}

	let isValid = false;
	await formEl.validate(async (valid, fields) => {
		isValid = valid;
	});

	return isValid;
};

export const resetForm = (formRef, id) => {
	if (!formRef || !id) {
		console.log('resetForm: formRef or id missing');
		return;
	}

	const formEl = formRef.$refs[id + 'Ref'];
	if (!formEl) {
		console.log('resetForm: formEl not found');
		return;
	}

	formEl.resetFields();
};

export const validatePassword = (rule, value, callback) => {
	if (!value) {
		return callback(new Error(texts.formErrors.pwReq));
	} else {
		const hasNumber = /\d/;
		const hasLowercase = /[a-z]/;
		const hasUppercase = /[A-Z]/;
		const hasNonAlphanumeric = /[^a-zA-Z\d]/;
		const minLength = 8;

		if (value.length < minLength) {
			callback(new Error(texts.formErrors.pwInvalid));
		} else if (!hasNumber.test(value)) {
			callback(new Error(texts.formErrors.pwInvalid));
		} else if (!hasLowercase.test(value)) {
			callback(new Error(texts.formErrors.pwInvalid));
		} else if (!hasUppercase.test(value)) {
			callback(new Error(texts.formErrors.pwInvalid));
		} else if (!hasNonAlphanumeric.test(value)) {
			callback(new Error(texts.formErrors.pwInvalid));
		} else {
			callback();
		}
	}
};

export const validateCategory = (rule, value, callback) => {
	if (!value || !value.number) {
		callback(new Error(texts.formErrors.categoryMissing));
	} else {
		callback();
	}
};

export const validateMedium = (rule, value, callback) => {
	if (!value || !value.name) {
		callback(new Error(texts.formErrors.mediumMissing));
	} else {
		callback();
	}
};

export const validateCheckbox = (rule, value, callback) => {
	if (value !== true) {
		callback(new Error(texts.formErrors.reqMissing));
	} else {
		callback();
	}
};

export const dialogBeforeClose = (done, waiting) => {
	// only allow dialog to close if waiting is false
	if (waiting === false) {
		done();
	}
};

export const hasArrayChanged = (oldData, newData) => {
	// check deepEqual
	if (JSON.stringify(oldData) === JSON.stringify(newData)) {
		return false;
	} else {
		return true;
	}
};

const normalizeData = (data) => {
	if (data && typeof data === 'object' && !Array.isArray(data)) {
		return Object.keys(data).reduce((acc, key) => {
			acc[key] = data[key] === null || data[key] === '' ? null : normalizeData(data[key]);
			return acc;
		}, {});
	}
	return data === null || data === '' ? null : data;
};

export const hasFormChanged = (formData: any, newFiles?: any[], newLinks?: any[]) => {
	const { initialData, currentData } = formData;

	if ((newFiles && newFiles.length > 0) || (newLinks && newLinks.length > 0)) {
		return true;
	}

	// check other form fields
	const normalizedCurrentData = normalizeData(currentData);
	const normalizedInitialData = normalizeData(initialData);

	if (JSON.stringify(normalizedCurrentData) !== JSON.stringify(normalizedInitialData)) {
		return true;
	}
};

export const checkIsMobile = () => {
	return window.innerWidth <= 765;
};

export const getEndOfDayWithTime = (date: string, toISOString: boolean = true) => {
	return moment(date).set({ hour: 23, minute: 55, second: 0, millisecond: 0 }).toISOString(toISOString);
};

export const getStartOfDayWithTime = (date: string, hour = 0) => {
	return moment(date).set({ hour: hour, minute: 0, second: 0, millisecond: 0 }).toISOString(true);
};
